import { GqlClient } from '../gql';
import tradeQql from './trade-qql';

export default class ConfigService {
  public gqlRequestClient: GqlClient;

  constructor(gqlRequestClient: GqlClient) {
    this.gqlRequestClient = gqlRequestClient;
  }

  public getUserGeolocation(): Promise<{
    geolocation: { country_code: string; country_name: string };
  }> {
    return this.gqlRequestClient.request(tradeQql.getUserGeolocation());
  }

  public getMaintenance(): Promise<{
    healthcheck: { maintenance_mode: boolean; maintenance_message: string };
  }> {
    return this.gqlRequestClient.request(tradeQql.getMaintenance());
  }
}
